"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
vue_1.default.directive("click-outside", {
    bind: function bind(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function" && _typeof(binding.value) !== "object" || _typeof(binding.value) === "object" && (!binding.value.handler || typeof binding.value.handler !== "function")) {
            var compName = vNode.context.name;
            var warn = "[Vue-click-outside:] provided expression '" + binding.expression + "' is not a function, but has to be";
            if (compName) {
                warn += "Found in component '" + compName + "'";
            }
            console.warn(warn);
        }
        // Define Handler and cache it on the element
        var bubble = binding.modifiers.bubble;
        var handler = function handler(e) {
            var control = _typeof(binding.value) === "object" && binding.value.target ? $(binding.value.target)[0] || el : el;
            if (bubble || !control.contains(e.target) && control !== e.target) {
                if (_typeof(binding.value) === "object") {
                    binding.value.handler(e);
                } else {
                    binding.value(e);
                }
            }
        };
        el.__vueClickOutside__ = handler;
        // add Event Listeners
        document.addEventListener("click", handler);
    },
    unbind: function unbind(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el["__vueClickOutside__"]);
        el["__vueClickOutside__"] = null;
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/Directives/ClickOutside/index.ts
// module id = 638
// module chunks = 0